// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderItems-orderCardItemContainer-rdJ5D {
    border: 1px solid var(--primary-border);
    padding: 12px;
    border-radius: var(--radius-3);
    background: var(--background-primary);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 12px;
    grid-gap: 12px;
}

.OrderItems-orderCardItemImgContainer-go4Es {
    position: relative;
    width: 69px;
    height: 69px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.OrderItems-orderCardItemImgContainer-go4Es img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
    -o-object-position: center;
       object-position: center;
}

.OrderItems-orderCardItemInfoType-MIWn8 {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 18px;
    grid-gap: 18px;
}

.OrderItems-orderCardItemInfoTypeWrapper-fKTea {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    width: 100%;
}

.OrderItems-orderItemsRangeBtn-S9c0j {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 8px;
    grid-gap: 8px;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: var(--primary-foreground);
    white-space: noWrap;
}

.OrderItems-orderItemsRangeBtnIcon-p9t0a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--primary-bg);
    cursor: pointer;
}

.OrderItems-orderItemsRangeBtnIcon-p9t0a img {
    width: 14px;
    height: 14px;
}

.OrderItems-orderItemsRangeDisabledBtnIcon-e9wnM {
    background: var(--secondary-disable);
    cursor: not-allowed;
}

.OrderItems-orderItemsBtnContainer-wqDXj {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

@media (max-width: 440px) {
    .OrderItems-orderCardItemInfoType-MIWn8 {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        gap: 6px;
        grid-gap: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BookingDetail/OrderItems/OrderItems.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kDAAkD;IAClD,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;IACtB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oBAAc;QAAd,cAAc;IACd,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;QACvB,QAAQ;QACR,aAAa;IACjB;AACJ","sourcesContent":[".orderCardItemContainer {\n    border: 1px solid var(--primary-border);\n    padding: 12px;\n    border-radius: var(--radius-3);\n    background: var(--background-primary);\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.orderCardItemImgContainer {\n    position: relative;\n    width: 69px;\n    height: 69px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n    flex-shrink: 0;\n}\n\n.orderCardItemImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n    object-position: center;\n}\n\n.orderCardItemInfoType {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.orderCardItemInfoTypeWrapper {\n    flex-grow: 1;\n    width: 100%;\n}\n\n.orderItemsRangeBtn {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    grid-gap: 8px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: var(--primary-foreground);\n    white-space: noWrap;\n}\n\n.orderItemsRangeBtnIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--primary-bg);\n    cursor: pointer;\n}\n\n.orderItemsRangeBtnIcon img {\n    width: 14px;\n    height: 14px;\n}\n\n.orderItemsRangeDisabledBtnIcon {\n    background: var(--secondary-disable);\n    cursor: not-allowed;\n}\n\n.orderItemsBtnContainer {\n    flex-shrink: 0;\n}\n\n@media (max-width: 440px) {\n    .orderCardItemInfoType {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 6px;\n        grid-gap: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderCardItemContainer": `OrderItems-orderCardItemContainer-rdJ5D`,
	"orderCardItemImgContainer": `OrderItems-orderCardItemImgContainer-go4Es`,
	"orderCardItemInfoType": `OrderItems-orderCardItemInfoType-MIWn8`,
	"orderCardItemInfoTypeWrapper": `OrderItems-orderCardItemInfoTypeWrapper-fKTea`,
	"orderItemsRangeBtn": `OrderItems-orderItemsRangeBtn-S9c0j`,
	"orderItemsRangeBtnIcon": `OrderItems-orderItemsRangeBtnIcon-p9t0a`,
	"orderItemsRangeDisabledBtnIcon": `OrderItems-orderItemsRangeDisabledBtnIcon-e9wnM`,
	"orderItemsBtnContainer": `OrderItems-orderItemsBtnContainer-wqDXj`
};
module.exports = ___CSS_LOADER_EXPORT___;
